/* istanbul ignore file */
<script>
import { mapState } from 'vuex';
import settingsEditor from '@components/common/settingsEditor/settingsEditor.vue';

const settingsMap = {
    cId: '123abc',
    cType: 'recruiterSignin',
    cTitle: 'Recruiter Signin',
    cTemplate: `<div class="signin-component">
                    <settings-editor :prop-settingsMap="settingsMap" :prop-settings="settings"></settings-editor>

                    <h1 class="signin-title">{{ settings.userLabel }} Signin</h1>
                    <h2 v-if="settings.showSubtitle" class="signin-subtitle">Please sign in below</h2>

                    <div class="slots-container">
                        <div v-for="(slot, idx) in slots" :key="idx" class="slot">slot</div>
                    </div>

                    <div class="welcome-message-container">
                        <p class="welcome-message" :style="{ color: settings.welcomeMessageColor }">Welcome, Volunteers!</p>
                    </div>

                    <div>
                        <h3>First Date to Show</h3>
                        <p>{{ settings.firstDateToShow }}</p>
                    </div>

                    <div class="allowed-image-types">
                        <h3>Image types allowed:</h3>
                        <ul class="allowed-image-types-list" v-if="settingsMap.imageTypesAllowed">
                            <li v-for="(option, index) in settingsMap.imageTypesAllowed.options" :key="index" class="image-type">
                                <div v-if="settings.imageTypesAllowed[option.sysVal]">
                                    {{ option.label }}
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div
                        class="signin-container"
                        :class="[
                            {
                                'flex-justify-left': this.settings.signinBoxPosition === 'LEFT',
                                'flex-justify-right': this.settings.signinBoxPosition === 'RIGHT',
                                'flex-justify-center': this.settings.signinBoxPosition === 'CENTER'
                            }
                        ]"
                    >
                        <div class="signin">
                            <div class="text-input">
                                <label for="username_input" class="text-input-label">Username</label>
                                <input id="username_input" v-model="username" class="e-input" type="text" />
                            </div>
                            <div class="text-input">
                                <label for="password_input" class="text-input-label">Password</label>
                                <input id="password_input" v-model="password" class="e-input" type="text" />
                            </div>
                        </div>
                    </div>
                </div>`,
    showSubtitle: {
        id: 'showSubtitle',
        label: 'Show Subtitle',
        type: 'BOOLEAN',
        default: true,
        message: 'This setting hides and displays the subtitle'
    },
    userLabel: {
        id: 'userLabel',
        label: 'User Label',
        type: 'string',
        default: 'Volunteer',
        labelSrOnly: false,
        message: 'This setting dictates the label of the user',
        placeholder: 'Volunteer',
        width: '350px'
    },
    numberOfSlotsToShow: {
        id: 'numberOfSlotsToShow',
        label: 'Number of Slots to Show',
        type: 'NUMBER',
        default: 10,
        labelSrOnly: false,
        message: 'This setting changes the default number of slots shown',
        placeholder: 'Up to 100',
        min: 3,
        max: 100,
        width: '200px'
    },
    firstDateToShow: {
        id: 'firstDateToShow',
        label: 'First Date to Show',
        type: 'DATE',
        default: 'today',
        message: 'This setting changes the default start date of slots to show',
        placeholder: 'Enter Date',
        width: '250px'
    },
    welcomeMessageColor: {
        id: 'welcomeMessageColor',
        label: 'Welcome Message Color',
        type: 'COLOR',
        default: '#0000ff',
        message: 'This setting changes the default start date of slots to show',
        placeholder: '#ffffff'
    },
    imageTypesAllowed: {
        id: 'imageTypesAllowed',
        label: 'Image Types Allowed',
        type: 'CHECKBOX_LIST',
        message: 'This setting changes the types of images a user may upload',
        height: '100px',
        options: [
            { sysVal: 'jpeg', label: 'jpeg', default: true },
            { sysVal: 'jpg', label: 'jpg', default: false },
            { sysVal: 'png', label: 'png', default: true },
            { sysVal: 'gif', label: 'gif', default: true },
            { sysVal: 'tiff', label: 'tiff', default: false },
            { sysVal: 'pdf', label: 'pdf', default: false }
        ]
    },
    signinBoxPosition: {
        id: 'signinBoxPosition',
        label: 'Signin Box Position',
        type: 'RADIO_BUTTON_LIST',
        default: 'LEFT',
        message: 'This setting changes the position of the signin box',
        height: '100px',
        options: [
            { sysVal: 'LEFT', label: 'Left' },
            { sysVal: 'RIGHT', label: 'Right' },
            { sysVal: 'CENTER', label: 'Center' }
        ]
    },
    defaultOppSort: {
        id: 'defaultOppSort',
        label: 'Default Opp Sort',
        type: 'dropdown',
        message: 'This setting changes the default sorting of opps',
        height: '100px',
        placeholder: 'Select an option',
        options: [
            { sysVal: 'CREATED', label: 'Created', default: true },
            { sysVal: 'EVENT_DATE', label: 'Event Date' },
            { sysVal: 'NAME', label: 'Name' },
            { sysVal: 'AVAILABLE_SLOTS', label: 'Available Slots' }
        ]
    }
};

const settings = {
    showSubtitle: true,
    userLabel: 'Volunteer',
    numberOfSlotsToShow: 10,
    firstDateToShow: 'today',
    welcomeMessageColor: '#0000ff',
    imageTypesAllowed: {
        jpeg: true,
        jpg: false,
        png: true,
        gif: true,
        tiff: false,
        pdf: false
    },
    signinBoxPosition: 'RIGHT',
    defaultOppSort: 'CREATED'
};

const recruiterSigninComponent = {
    name: 'recruiterSignin',
    components: {
        settingsEditor
    },
    data() {
        return {
            username: '',
            password: '',
            settingsMap: settingsMap,
            settings: settings,
            loading: true
        };
    },
    computed: {
        ...mapState('componentList', ['components']),
        slots() {
            let slotsArr = [];
            if (this.settings) {
                for (let iter = 0; iter < this.settings.numberOfSlotsToShow; iter++) {
                    slotsArr.push(iter + 1);
                }
            }
            return slotsArr;
        }
        // signinBoxPosition() {
        //     switch (this.settings.signinBoxPosition) {
        //         case 'LEFT':
        //             return 'flex-start';
        //         case 'CENTER':
        //             return 'center';
        //         case 'RIGHT':
        //             return 'flex-end';
        //         default:
        //             return 'center';
        //     }
        // }
    }
};

componentStore.initComponent(recruiterSigninComponent, settingsMap);
export default recruiterSigninComponent;
</script>

<style lang="css" scoped>
h3 {
    margin: 20px 0 10px;
    font-size: 20px;
}
.signin-component {
    position: relative;
    min-height: 500px;
    background-color: pink;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.signin-container {
    width: 100%;
    display: flex;
}
.signin-title {
    margin: 20px 0 5px;
}
.signin {
    height: 300px;
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    background-color: aquamarine;
}
.text-input {
    margin: 30px 0;
    width: 350px;
}
.input-info {
    color: #2973b7;
}
.slots-container {
    margin: 20px;
    display: flex;
    flex-wrap: wrap;
}
.slot {
    height: 20px;
    width: 50px;
    margin: 5px;
    background-color: blue;
    color: #fff;
}
.welcome-message-container {
    margin: 20px 0 10px;
}
.welcome-message {
    font-size: 24px;
    font-weight: bold;
}
.flex-justify-left {
    justify-content: flex-start;
}
.flex-justify-right {
    justify-content: flex-end;
}
.flex-justify-center {
    justify-content: center;
}
.allowed-image-types-list {
    list-style-type: none;
}
</style>
